import { omit } from 'ramda';

export default omit;
